import { compose } from 'recompose';
import _trim from 'lodash/trim';
import _toLower from 'lodash/toLower';
import _includes from 'lodash/includes';
export var trimAndToLower = compose(_toLower, _trim);

var isSubString = function isSubString(stringToCompare, subString) {
  var stringToCompareInLowerCase = trimAndToLower(stringToCompare);
  var subStringInLowerCase = trimAndToLower(subString);
  return _includes(stringToCompareInLowerCase, subStringInLowerCase);
};

export default isSubString;